/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Ocop_Level_NationalInputs */

const vi_shop_home_ocop_level_national = /** @type {(inputs: Shop_Home_Ocop_Level_NationalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cấp quốc gia`)
};

/**

* @param {Shop_Home_Ocop_Level_NationalInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_ocop_level_national = /** @type {((inputs?: Shop_Home_Ocop_Level_NationalInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Ocop_Level_NationalInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_ocop_level_national(inputs)
});